export default [
  {
    login: "sbd26",
    id: 93975218,
    node_id: "U_kgDOBZnysg",
    avatar_url: "https://avatars.githubusercontent.com/u/93975218?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/sbd26",
    html_url: "https://github.com/sbd26",
    followers_url: "https://api.github.com/users/sbd26/followers",
    following_url: "https://api.github.com/users/sbd26/following{/other_user}",
    gists_url: "https://api.github.com/users/sbd26/gists{/gist_id}",
    starred_url: "https://api.github.com/users/sbd26/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/sbd26/subscriptions",
    organizations_url: "https://api.github.com/users/sbd26/orgs",
    repos_url: "https://api.github.com/users/sbd26/repos",
    events_url: "https://api.github.com/users/sbd26/events{/privacy}",
    received_events_url: "https://api.github.com/users/sbd26/received_events",
    type: "User",
    site_admin: false,
  },
];
